/* eslint-disable @typescript-eslint/no-explicit-any */

import classNames from 'classnames';
import React, { ReactNode } from 'react';

import { FooterLayout } from '../Main/components/Footer';
import { HeaderLayout } from '../Main/components/Header';

import PageWrap from '@/components/PageWrap';
import './style.scss';

interface IProps {
    className?: string;
    children?: ReactNode;
    title: string;
    actionHeader?: IActionButton[];
    actionFooter?: IActionButton[];
    isBack?: boolean;
    isImport?: boolean;
    multipleStore?: boolean;
    api?: string;
    storeName?: string;
    dateFilter?: string;
    onHandleModal?: () => void;
}

interface IActionButton {
    title: string;
    url?: string;
    icon?: React.ReactNode;
    exportCsv?: (data?: any) => void;
    isLoading?: boolean;
    onClick?: () => void;
}

const LayoutContent: React.FC<IProps> = ({
    title,
    children,
    className,
    actionHeader,
    actionFooter,
    isBack,
    isImport,
    multipleStore,
    api,
    storeName,
    dateFilter,
    onHandleModal,
}) => {
    return (
        <PageWrap>
            <HeaderLayout
                onHandleModal={onHandleModal}
                isImport={isImport}
                multipleStore={multipleStore}
                api={api}
                isBack={isBack}
                title={title}
                actions={actionHeader}
                storeName={storeName}
                dateFilter={dateFilter}
            />
            <div className={classNames('l-content__wrap', `${className}`)}>{children}</div>
            <FooterLayout actions={actionFooter} />
        </PageWrap>
    );
};

export default React.memo(LayoutContent);
